import React from "react";

// components
import Bio from "../Bio";

// assets
import bioImg from "../../../assets/images/Adam-Baxter.jpg";

const AdamBBio = (props) => {
  const bioData = {
    title: "Adam Baxter",
    title2: props.title2,
    hashName: "adam-baxter",
    bio1: `Adam Baxter has served as a member of our board of directors since September 2024 and as our Secretary and as Secretary of our Sponsor and Advisor since July 2025. Mr. Baxter has been a Managing Director with HMC Capital, the parent company of our Sponsor, since September 2024. In this role, Mr. Baxter oversees growth initiatives and corporate development for HMC Capital in North America. Mr. Baxter has over 22 years’ experience across roles within the law, investment banking and asset management. Prior to his role at HMC Capital, Mr. Baxter was a Managing Director of Argo Infrastructure Partners from March 2023 to September 2024, and a Managing Director at Macquarie Group in New York from May 2005 to February 2023. Within these roles, Mr. Baxter has extensive experience across infrastructure investment, capital raising and asset management, including within the infrastructure real estate sector. Before this, Mr. Baxter was a barrister and solicitor in Australia with Mallesons Stephen Jaques, where he practiced corporate and securities law. Mr. Baxter holds a Bachelor of Commerce and a Bachelor of Laws from Murdoch University in Australia, and also holds FINRA Series 7, 24 and 63 licenses. Mr. Baxter is a valuable member of our board of directors because of extensive financial, investment and asset management experience, including in infrastructure real estate.`,
  };
  return (
    <Bio
      srcImg={bioImg}
      title1={bioData.title}
      title2={bioData.title2}
      hashName={bioData.hashName}
      bio1={bioData.bio1}
      closeBio={props.closeBio}
    />
  );
};

export default AdamBBio;
